import React from "react";

import { Subscribe } from "unstated";

import { ProfileContainer } from "./containers/profile-container";

import { Form, Field } from "react-final-form";

import { FORM_ERROR } from "final-form";

import {
  required,
  nonEmptyString,
  email,
  date,
  phone,
  maxLength,
  composeField
} from "../lib/form-validators";
import { phoneFormatter } from "../lib/form-formatters";
import { phoneParser, stringParser } from "../lib/form-parsers";

import { TextInput } from "../components/ui/text-input";
import { FormErrors } from "../components/ui/form-errors";

import _ from "lodash";

import navigation from "../lib/navigation-utilities";

const ProfileCreate = () => {
  const onSubmit = (profileContainer) => async (values) => {
    const params = _.pick(values, [
      "firstName",
      "lastName",
      "email",
      "dateOfBirth",
      "homePhoneNumber",
      "mobilePhoneNumber",
      "workPhoneNumber"
    ]);

    return profileContainer
      .createProfile(params)
      .then(() => navigation.push("/account/profile"))
      .catch(() => {
        return { [FORM_ERROR]: "Failed to create Profile" };
      });
  };

  return (
    <Subscribe to={[ProfileContainer]}>
      {(profileContainer) => (
        <div className="container p-2">
          <div className="row">
            <div className="col-sm-6">
              <Form
                onSubmit={onSubmit(profileContainer)}
                initialValues={{ dateOfBirth: new Date() }}
                render={({
                  handleSubmit,
                  submitting,
                  submitError,
                  dirtySinceLastSubmit
                }) => (
                  <form id="createProfile" onSubmit={handleSubmit}>
                    <Field
                      name="firstName"
                      parse={stringParser}
                      validate={composeField(nonEmptyString, maxLength(64))}
                      render={TextInput}
                      placeholder="First Name"
                      type="text"
                    />

                    <Field
                      name="lastName"
                      validate={composeField(nonEmptyString, maxLength(64))}
                      render={TextInput}
                      placeholder="Last Name"
                      type="text"
                    />

                    <Field
                      name="email"
                      parse={stringParser}
                      validate={composeField(
                        nonEmptyString,
                        email,
                        maxLength(256)
                      )}
                      render={TextInput}
                      placeholder="Email"
                      type="text"
                    />

                    <Field
                      name="dateOfBirth"
                      validate={composeField(required, date)}
                      render={TextInput}
                      placeholder="Date of Birth"
                      type="date"
                      caption="* I am at least 21 years of age"
                    />

                    <Field
                      name="homePhoneNumber"
                      validate={composeField(phone)}
                      format={phoneFormatter}
                      parse={phoneParser}
                      formatOnChange={true}
                      render={TextInput}
                      placeholder="Home Phone Number"
                      type="tel"
                    />

                    <Field
                      name="mobilePhoneNumber"
                      format={phoneFormatter}
                      parse={phoneParser}
                      formatOnChange={true}
                      validate={composeField(phone)}
                      render={TextInput}
                      placeholder="Mobile Phone Number"
                      type="tel"
                    />

                    <Field
                      name="workPhoneNumber"
                      format={phoneFormatter}
                      parse={phoneParser}
                      formatOnChange={true}
                      validate={composeField(phone)}
                      render={TextInput}
                      placeholder="Work Phone Number"
                      type="tel"
                    />

                    <FormErrors
                      submitError={submitError}
                      dirtySinceLastSubmit={dirtySinceLastSubmit}
                    />
                  </form>
                )}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center mt-4">
              <button
                className="btn btn-primary btn-wide"
                onClick={() =>
                  document
                    .getElementById("createProfile")
                    .dispatchEvent(new Event("submit", { cancelable: true }))
                }>
                CREATE
              </button>
            </div>
          </div>
        </div>
      )}
    </Subscribe>
  );
};

export { ProfileCreate };
